export default function preventSubmitOnEnter() {
  $('.js-prevent-submit-on-enter').on('keypress', function (event) {
    const key = event.keyCode || event.which
    if (key === 13) {
      event.preventDefault()
      return false
    }
  })
}
